// get img for "post block" on archive page
export const getFirstImage = content => {
  if (content) {
    let contentSubstring = content.substring(
      content.indexOf('<img') + 4,
      content.indexOf('</figure>'),
    )

    contentSubstring = contentSubstring.substring(
      contentSubstring.indexOf('src="') + 5,
    )

    const altSubstring = contentSubstring.substring(
      contentSubstring.indexOf('alt="') + 5,
    )

    const sourceUrl = contentSubstring.substring(
      0,
      contentSubstring.indexOf('"'),
    )
    const altText = altSubstring.substring(0, altSubstring.indexOf('"'))

    if (sourceUrl) return { sourceUrl, altText }
  }
}

//get text for "post block" on archive page
export const getText = content => {
  if (content) {
    let qoute = content.substring(
      content.indexOf('<p>') + 3,
      content.indexOf('</p>'),
    )

    const contentSubstring = content.substring(content.indexOf('</p>') + 4)

    qoute += ` ${contentSubstring.substring(
      contentSubstring.indexOf('<p>') + 3,
      contentSubstring.indexOf('</p>'),
    )}`

    // Remove <a>+text and all <**> </**>
    return qoute.replace(/<a[^>]*>.*?<\/a>/g, '').replace(/<.*?>|<\/.*?>/g, '')
  }
}
